<template>
  <div class="card">
    <div class="card-body">
      <div class="row justify-content-center">
        <div class="col-2 my-auto">
          <h4>
            {{ left }}
          </h4>
        </div>
        <div :class="givenClass + ' my-auto'" id="size-pic">
          <img :src="imgUrl" id="rose-size-pic" />
        </div>
        <div class="col-2 my-auto">
          <h4>
            {{ right }}
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoseSizeComponent",
  props: {
    left: String,
    right: String,
    imgUrl: String,
    givenClass: String,
  },
};
</script>

<style scoped>
.card {
  background: none !important;
  border: none !important;
}

#size-pic {
  border: 1px solid;
  border-top: none;
  border-bottom: none;
}

#rose-size-pic {
  height: 7em !important
}
</style>
